export function getFromMeta() {
  const tag = document.querySelector('meta[name=share-resource-token]');
  return (tag) ? tag.content : '';
}



// WEBPACK FOOTER //
// ./app/javascript/utils/shareResourceToken.js